<style lang="scss" scoped src="./index.scss"></style>
<style lang="scss">
// chatgpt
.chatgpt-service {
  position: absolute;
  right: -5px;
  top: -166px;
  width: 52px;
}

.app-help__box {
  &-badge {
    .el-badge__content.is-fixed {
      padding: 0 5px;
      right: 16px;
      top: 9px;
    }
  }
}

.app-help__Shits-popper {
  height: 124px;
  padding: 10px 16px;
  width: 120px !important;
}

.fade-enter-active {
  transition: all 0s;
}

.fade-leave-active {
  transition: all 0s;
}

</style>
<template>
    <div class="app-help">
        <!-- <div class="staff-entry" v-if="loginUser && loginUser.isNewEmp" @click="goNewEmp">
            <img src="./images/new.png" alt="新员工入职">
            <el-button size="mini" round type="primary">新员工入职</el-button>
        </div> -->
        <!-- chatgpt入口 -->
        <!-- <img class="chatgpt-service" src="./images/GPT_entrance.svg" @click="goChat"> -->
        <!-- 客服入口 -->
        <!-- <img class="app-help__service" src="./images/itRoot.png" @click="goToHelp"> -->
        <ul class="app-help__box">
          <el-tooltip transition="fade" :open-delay="0" class="item" effect="dark" :content="$t('others.backup')" placement="left">
                <li class="app-help__box-item" @click="pageScroll">
                  <a href="javascript:;" class="link">
                    <img src="./images/icon-zhiding@2x.png" />
                  </a>
                  <div class="flex-text">
                    <p>{{ $t('others.backup') }}</p>
                  </div>
                </li>
            </el-tooltip>
            <el-tooltip transition="fade" :open-delay="0" class="item" effect="dark" :content="$t('others.support')" placement="left">
                <li class="app-help__box-item" @click="support">
                    <a href="javascript:;" class="link">
                        <!-- <i class="iconfont icon-dianzan"></i> -->
                        <img src="./images/dianzan@2x.png" />
                    </a>
                    <div class="flex-text">
                      <p>{{ $t('others.support') }}</p>
                    </div>
                </li>
            </el-tooltip>
            <el-popover placement="left" title="" width="200" :visible-arrow="false" trigger="hover" :open-delay="100" popper-class="app-help__Shits-popper">
                <ul class="app-help__Shits">
                    <li style="padding-top: 0;" class="app-help__Shits-item" @click="goShift('应用太少')">{{$t('others.appLittle')}}</li>
                    <li class="app-help__Shits-item" @click="goShift('加载过慢')">{{$t('others.slow')}}</li>
                    <li class="app-help__Shits-item" @click="goShift('体验不好')">{{$t('others.experience')}}</li>
                </ul>
                <li slot="reference" class="app-help__box-item">
                    <a href="javascript:;" class="link">
                        <!-- <i class="iconfont icon-tucao"></i> -->
                        <img src="./images/yijian@2x.png" />
                    </a>
                    <div class="flex-text">
                      <p>{{ $t('others.opinion') }}</p>
                    </div>
                </li>
            </el-popover>
        </ul>
    </div>
</template>
<script>
export default {
  name: 'appHelp',
  data () {
    return {
      newWindow: '',
      goNewEmpUrl: process.env.NEW_EMPLOYEE_URL
    }
  },
  computed: {
    loginUser () {
      return this.$store.state.global.loginInfo
    }
  },
  methods: {
    /*
         * 客服中心
         **/
    goToHelp () {
      if (!this.loginUser) {
        this.$store.dispatch('global/domainLogin')
      } else {
        let newWindow = window.open()
        // 先判断session是否过期
        this.$store.dispatch('global/GET_LOGIN_STAGE').then(res => {
          // let url = `https://qiyukf.com/client?k=7a41e5f7b9f1a6a2674c0d778eb0d0a4&uuid=${this.loginUser.userId}&gid=528355&sid=0&qtype=0&dvctimer=0&robotShuntSwitch=1&robotId=182020&hc=0&t=${encodeURIComponent(encodeURIComponent('IT门户'))}`
          let url = 'https://cc.geely.com/chat/pc/v2/index.html?sysnum=6a06f951fa864cfca0d23b44fe1c34ba&channelid=12'
          newWindow.location.href = url
        }).catch((err) => {
          newWindow.close()
          if (err.code === 'user-not-login') this.$message(this.$t('others.sessionPast'))
        })
      }
    },
    // chatgpt入口
    goChat () {
      if (!this.loginUser) {
        this.$store.dispatch('global/domainLogin')
      } else {
        let newWindow = window.open()
        // 先判断session是否过期
        this.$store.dispatch('global/GET_LOGIN_STAGE').then(res => {
          // let url = `https://qiyukf.com/client?k=7a41e5f7b9f1a6a2674c0d778eb0d0a4&uuid=${this.loginUser.userId}&gid=528355&sid=0&qtype=0&dvctimer=0&robotShuntSwitch=1&robotId=182020&hc=0&t=${encodeURIComponent(encodeURIComponent('IT门户'))}`
          let url = 'https://oai.geely.com/chat'
          newWindow.location.href = url
        }).catch((err) => {
          newWindow.close()
          if (err.code === 'user-not-login') this.$message(this.$t('others.sessionPast'))
        })
      }
    },
    pageScroll() { 
      window.scrollBy(0,-5000);
    },
    /*
         * 点赞
         **/
    support () {
      if (!this.loginUser) {
        this.$store.dispatch('global/domainLogin')
      } else {
        this.$store.dispatch('global/GET_LOGIN_STAGE').then(res => {
          // 一天点赞一次
          let date = new Date()
          let preSupportDate = null
          if (localStorage.getItem('supportTime')) {
            preSupportDate = new Date(localStorage.getItem('supportTime'))
          }
          if (!preSupportDate || (date.getTime() > preSupportDate.getTime() && date.getDate() !== preSupportDate.getDate())) {
            this.$message({
              type: 'success',
              message: this.$t('ajaxMsg.praiseMsg')
            })
            localStorage.setItem('supportTime', new Date())
          } else {
            this.$message(this.$t('ajaxMsg.supportMax'))
          }
        }).catch((err) => {
          if (err.code === 'user-not-login') this.$message(this.$t('others.sessionPast'))
        })
      }
    },
    /*
         * 吐槽
         **/
    goShift (eventName) {
      if (!this.loginUser) {
        this.$store.dispatch('global/domainLogin')
      } else {
        this.$store.dispatch('global/GET_LOGIN_STAGE').then(res => {
          // 一天吐槽一次
          let date = new Date()
          let preShiftDate = null
          if (localStorage.getItem('shiftTime')) {
            preShiftDate = new Date(localStorage.getItem('shiftTime'))
          }
          if (!preShiftDate || (date.getTime() > preShiftDate.getTime() && date.getDate() !== preShiftDate.getDate())) {
            this.$message({
              type: 'success',
              message: this.$t('ajaxMsg.feedbackMsg')
            })
            localStorage.setItem('shiftTime', new Date())
          } else {
            this.$message(this.$t('ajaxMsg.shiftMax'))
          }
        }).catch((err) => {
          if (err.code === 'user-not-login') this.$message(this.$t('others.sessionPast'))
        })
      }
    },
    goNewEmp () {
      window.open(this.goNewEmpUrl)
    }
  }
}

</script>
